import React, { useEffect, useState } from "react";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";
import {
  useAddEveningEmployeeMutation,
  useAddMorningEmployeeMutation,
  useUpdateEveningEmployeeMutation,
  useUpdateMorningEmployeeMutation,
  useAssignEmployeForWashingMutation,
  useUpdateEmployeeWorkMutation,
} from "./washingApi";

import useTranslator from "../../../hooks/useTranslator";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import toast from "react-hot-toast";
import { convertToUserTimezone, getCurrentDateTime } from "../../../helpers/Utils";

const WashingModal = ({
  show,
  setShow,
  employee,
  mode,
  refetchEmployeeData,
  onSuccess,
}) => {
  const [addMorningEmployee] = useAddMorningEmployeeMutation();
  const [editMorningEmployee] = useUpdateMorningEmployeeMutation();
  const [editEveningEmployee] = useUpdateEveningEmployeeMutation();
  const [addEveningEmployee] = useAddEveningEmployeeMutation();
  const [assignEmployeForWashing] = useAssignEmployeForWashingMutation();
  const [updateEmployeeWork] = useUpdateEmployeeWorkMutation();

  const initialFormData = {
    date: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
    emp_total: "",
    orange_cases: "",
    red_cases: "",
    yellow_cases: "",
    carts: "",
    treys: "",
    knifes: "",
    bowls: "",
    shift: 1,
  };

  const { _t } = useTranslator();
  // SHIFT OPTION

  const shifts = [
    { value: 1, label: _t("morning", "Morning") },
    { value: 2, label: _t("evening", "Evening") },
  ];

  const yesNoOptions = [
    { value: "yes", label: _t("yes", "Yes") },
    { value: "no", label: _t("no", "No") },
  ];


  const [formData, setFormData] = useState(initialFormData);
  useEffect(() => {
    if (
      (mode === "editMorning" ||
        mode === "editEvening" ||
        mode === "editEmloyeWork") &&
      employee
    ) {
      // setFormData(employee); // assuming `employee` is the existing data object
      setFormData({
          ...employee,
          date: convertToUserTimezone(employee.date, "YYYY-MM-DDTHH:mm"), // 👈 override only date
  });
    } else {
      setFormData(initialFormData);
    }
  }, [mode, employee, show]);

  const mutationMap = {
    addMorning: addMorningEmployee,
    addEvening: addEveningEmployee,
    editMorning: editMorningEmployee,
    editEvening: editEveningEmployee,
    assignEmployee: assignEmployeForWashing,
    editEmloyeWork: updateEmployeeWork,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate knifes and bowls for evening shift and assignEmployee modes
    if (mode === "addEvening" || mode === "editEvening" || mode === "assignEmployee" || mode === "editEmloyeWork") {
      if (!formData.knifes) {
        toast.error(_t("please_select_knifes", "Please select a knife option."));
        return;
      }
      if (!formData.bowls) {
        toast.error(_t("please_select_bowls", "Please select a bowl option."));
        return;
      }
    }

    try {
      const selectedMutation = mutationMap[mode];

      if (!selectedMutation) throw new Error("Unknown mode");

      const payload = mode.startsWith("edit")
        ? { id: employee?.id, requestBody: formData }
        : formData;

      await selectedMutation(payload).unwrap();
      refetchEmployeeData();
      onSuccess?.();
      handleClose();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const renderFormFields = () => {
    if (mode === "addMorning" || mode === "editMorning") {
      return (
        <>
          <Col lg={6}>
            <InputWithLabel
              label={_t("date", "Date")}
              type="text"
              name="date"
              value={formData.date}
              disabled={true}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("total_employees", "Total Employee")}
              placeholder={"0"}
              type="number"
              name="emp_total"
              value={formData.emp_total}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("orange_cases", "Orange Cases")}
              placeholder={"0"}
              type="number"
              name="orange_cases"
              value={formData.orange_cases}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("red_cases", "Red Cases")}
              placeholder={"0"}
              type="number"
              name="red_cases"
              value={formData.red_cases}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("yellow_cases", "Yellow Cases")}
              placeholder={"0"}
              type="number"
              name="yellow_cases"
              value={formData.yellow_cases}
              onChange={handleChange}
            />
          </Col>
        </>
      );
    } else if (mode === "addEvening" || mode === "editEvening") {
      return (
        <>
          <Col lg={6}>
            <InputWithLabel
              label={_t("date", "Date")}
              type="text"
              name="date"
              value={formData.date}
              disabled={true}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("total_employees", "Total Employee")}
              placeholder={"0"}
              type="number"
              name="emp_total"
              value={formData.emp_total}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("carts", "Carts")}
              placeholder={"0"}
              type="number"
              name="carts"
              value={formData.carts}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("treys", "Trey")}
              placeholder={"0"}
              type="number"
              name="treys"
              value={formData.treys}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("knifes", "Knifes")}
              placeholder={"0"}
              type="number"
              name="knifes"
              value={formData.knifes}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("bowls", "Bowls")}
              placeholder={"0"}
              type="number"
              name="bowls"
              value={formData.bowls}
              onChange={handleChange}
            />
          </Col>
        </>
      );
    } else if (mode === "assignEmployee" || mode === "editEmloyeWork") {
      return (
        <>
          <Col lg={6}>
            <InputWithLabel
              label={_t("date", "Date")}
              type="datetime-local"
              name="date"
              value={formData.date}
              onChange={handleChange}
              min={getCurrentDateTime("YYYY-MM-DDTHH:mm")}
              disabled={true}
            />
          </Col>
          <Col lg={6}>
            <SelectBox
              label={_t("select_shift", "Select Shift")}
              name="shift" // Changed shift
              value={formData.shift}
              onChange={handleChange}
              options={shifts}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("total_employees", "Total Employee")}
              placeholder={"0"}
              type="number"
              name="emp_total"
              value={formData.emp_total}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("orange_cases", "Orange Cases")}
              placeholder={"0"}
              type="number"
              name="orange_cases"
              value={formData.orange_cases}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("red_cases", "Red Cases")}
              placeholder={"0"}
              type="number"
              name="red_cases"
              value={formData.red_cases}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("yellow_cases", "Yellow Cases")}
              placeholder={"0"}
              type="number"
              name="yellow_cases"
              value={formData.yellow_cases}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("carts", "Carts")}
              placeholder={"0"}
              type="number"
              name="carts"
              value={formData.carts}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("treys", "Trey")}
              placeholder={"0"}
              type="number"
              name="treys"
              value={formData.treys}
              onChange={handleChange}
            />
          </Col>
          <Col lg={6}>
            <SelectBox
              label={_t("knifes", "Knifes")}
              name="knifes"
              value={formData.knifes}
              onChange={handleChange}
              options={yesNoOptions}
              required={true}
            />
          </Col>
          <Col lg={6}>
            <SelectBox
              label={_t("bowls", "Bowls")}
              name="bowls"
              value={formData.bowls}
              onChange={handleChange}
              options={yesNoOptions}
              required={true}
            />
          </Col>
        </>
      );
    }
  };
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "addMorning" || mode === "editMorning"
          ? _t("morning_shift", "Morning Shift")
          : mode === "addEvening" || mode === "editEvening"
          ? _t("evening_shift", "Evening Shift")
          : mode === "assignEmployee"
          ? _t("add_employee_shift_data", "Add Employee Shift Data")
          : mode === "editEmloyeWork"
          ? _t("edit_employee_shift_data", "Edit Employee Shift Data")
          : ""
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            isLoading={"isCreating" || "isUpdating"}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default WashingModal;
